import Tprofie from "../images/products/Tshape.jpg"
import Uprofie from "../images/products/Ushape.jpg"
import TransitionProfie from "../images/products/TransitionShape.jpg"
import TileEdgeProfie from "../images/products/TileEdgeingShape.jpg"
import CornerProfie from "../images/products/CornerProtectionShape.jpg"
import SolidProfie from "../images/products/SolidShape.jpg"
import StairNoisingProfie from "../images/products/StairNoisingShape.jpg"
import DecorProfie from "../images/products/DecorProfile.jpg"

export const productCategories = [
  { key: "t-profiles", title: "T Profiles", desc: "Elegant transition solution for level surfaces and design accents.", img: Tprofie},
  { key: "u-profiles", title: "U Profiles", desc: "Clean channel finish for inlays, partitions, and trims.", img: Uprofie },
  { key: "transition", title: "Transition Profiles", desc: "Smooth movement between floor materials and levels.", img: TransitionProfie },
  { key: "tile-edge", title: "Tile Edge Profiles", desc: "Protects tile edges while adding a refined border.", img: TileEdgeProfie},
  { key: "corner", title: "Corner Protection Profiles", desc: "High‑wear edge guards for walls, pillars, and counters.", img: CornerProfie},
  { key: "solid", title: "Solid Profiles", desc: "Heavy‑duty sections for structural trims and premium finish.", img: SolidProfie},
  { key: "stair-nosing", title: "Stair Nosing Profiles", desc: "Anti‑slip and edge protection for steps and landings.", img: StairNoisingProfie },
  { key: "decor-sheets", title: "SS Decorative Sheets", desc: "Embossed, etched, hairline & mirror sheets for feature walls.", img: DecorProfie }
];
